import { safeJson } from "src/app/helpers/Index";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { Fixture, Goal, Player } from "src/app/interfaces/Index";
import { FixtureService, GoalService, PlayerService } from "src/app/services/Index";
import "./ScoreboardAwayTeam.css";

type Props = {};
type State = {
	currentIndex: number;
	currentPlayer: Player;
	team: Player[];
	teamName: string;
};
export class ScoreboardAwayTeam extends React.Component<Props, State> {
	
	constructor(props: Props) {
		super(props);
		this.state = {currentPlayer: new Player, currentIndex: 0, team: [], teamName: ""};
	}

	componentDidMount() {
		this.getTeam();		
		let loop = setInterval(() => this.setIndex(), 5000);
	}

	setIndex() {
		let index = this.state.currentIndex === this.state.team.length - 1 ? 0 : this.state.currentIndex + 1;
		let currentItem = this.state.team[index];
		this.setState({ currentIndex: index, currentPlayer: currentItem });
	  }
	
	render() {
		return (
			<div id="scoreboard-wrapper2" style={{textAlign: "center", width:576, height:432}}>
				<Row>
				<h1 className="team-heading">{this.renderHeading()}</h1>
				</Row>
				<Row style={{height:"79%"}}>
				<Col style={{position: "relative"}}>
				<h1 style={{paddingLeft:20,paddingTop:20,float:"left",flex:0.3,flexDirection: "column",flexWrap: "wrap", alignContent: "center", whiteSpace: "break-spaces", textAlign: "center"}}>{this.state.currentPlayer?.playerNumber}. {this.state.currentPlayer?.playerName}</h1>
				</Col>
				<Col style={{position: "relative"}}><img src={this.state.currentPlayer?.mugshotUrl} width="250" style={{position: "absolute",bottom:-20, right:30}}/></Col>
				</Row>				
				
			</div>
		);
	}

	async getTeam(){
		const fixRes = await safeJson(FixtureService.getLatest());
		if (fixRes && fixRes.error) {
		}
		let fixture: Fixture = fixRes;

		// No fixture means no squad to read off it. Leave the board as it is
		// rather than taking it down chasing a team that isn't there.
		if (!fixture) return;

		const res = await safeJson(PlayerService.getByTeam(fixture.teamId));
		if (res && res.error) {
		}
		let all: Player[] = Array.isArray(res) ? res : [];

		if (!all.length) return;

		let starting = all.filter(x=>x.playerStatus === 0).sort(({playerNumber:a}, {playerNumber:b}) => a-b);
		let subs = all.filter(x=>x.playerStatus === 10).sort(({playerNumber:a}, {playerNumber:b}) => a-b);
		let allPlayers = [ ...starting, ...subs];
		this.setState({team: allPlayers, currentPlayer: allPlayers[0], teamName: fixture.team?.teamNameShort});
	}

	renderHeading(){
		if(this.state.currentPlayer.playerStatus !== 0) return this.state.teamName + " - SUBS"
		else return this.state.teamName + " - STARTING"
		
	}
}